<template>
  <div class="quickregistration my-8 bg-grey-lighter p-4 rounded border-l-4 border-green-heinz">
    <h2 v-if="!isLoggedIn" class="border-0 mb-0 pb-1">Du bist noch nicht bei foodi.de registriert?</h2>

    <div class="pb-6">
      <template v-if="!isLoggedIn">Melde dich jetzt an und erhalte</template>
      <template v-if="isLoggedIn">Erhalte</template>
      jeden Monat 3 Gutscheine á 5,00 € für deine Freunde, die foodi.de noch nicht kennen!<br />
      Sobald einer der Gutscheine eingesetzt wird, erhälst du ebenfalls einen Gutschein in gleicher Höhe für dich.
    </div>
    <div v-if="isLoggedIn" class="pb-6">
      <router-link tag="button" :to="{ name: 'Einstellungen' }" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded">zu den Gutscheinen</router-link>
    </div>

    <div v-if="registrationResponse" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-4" role="alert">
      <p v-html="registrationResponse"></p>
    </div>

    <form v-if="!isLoggedIn && !registrationCompleted" class="max-w-xl" :class="{ 'opacity-25': isLoading }" v-on:submit.prevent="register()">
      <div class="w-full mb-6 md:mb-0">
        <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-comment">
          Passwort festlegen und direkt starten
        </label>
        <input v-model="password" required minlength="8" type="password" class="block w-full max-w-sm text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-comment" />
      </div>
      <div class="w-full">
        <input type="submit" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-2 py-2 px-4 rounded" value="kostenlos Registrieren" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import endpoints from '../endpoints'
import axios from 'axios'

export default {
  name: 'Quickregistration',

  data () {
    return {
      password: {},
      registrationResponse: '',
      registrationCompleted: false,
      isLoading: false
    }
  },

  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  },

  methods: {
    ...mapActions([
      'login'
    ]),

    register: function (event) {
      if (event) event.preventDefault()
      this.isLoading = true

      axios.post(endpoints.userRegistration, {
        item_password: this.password
      })
        .then(({data}) => {
          this.isLoading = false
          this.registrationResponse = data.registrationResponse
          this.registrationCompleted = data.success

          if (data.success) {
            this.login({
              email: data.account,
              password: this.password
            })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Quickregistration.vue